import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const engagementMechanismDefinition: ResourceDefinition = {
  title: 'Engagement Mechanisms',
  nameSingular: 'Engagement Mechanism',
  namePlural: 'Engagement Mechanisms',
  className: 'EngagementMechanism',
  mainIdentifier: 'name',
  slug: 'taxonomies/engagement-mechanisms',
  path: 'engagement-mechanisms',
  icon: 'icon-tag',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editPolicyInitiativeTaxonomies',
      action: (engagementMechanism) => ({
        type: ActionType.Link,
        link: {
          path: `${engagementMechanismDefinition.path}/${engagementMechanism.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deletePolicyInitiativeTaxonomies',
      action: (engagementMechanism) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: engagementMechanism,
          definition: engagementMechanismDefinition
        }
      })
    }
  ]
}
